import axios from '../../common/axios';
import { store } from '../../redux/store';
import type { Circle } from '../../pages/circles-page/types';
import { slice } from './slice';

export function loadSidebarPeers() {
  return async () => {
    const { dispatch, getState } = store;
    dispatch(slice.actions.startLoading());
    const orgGuidAtStart = getState().organizationContext.activeOrgGuid;
    try {
      const circlesResponse = await axios.get<Circle[]>('/circle');

      // The active org may have changed while this request was in flight (e.g. the
      // user switched again before this call resolved). Discard results scoped to a
      // context that's no longer active — a newer dispatch already owns the sidebar.
      if (getState().organizationContext.activeOrgGuid !== orgGuidAtStart) return;

      dispatch(
        slice.actions.loadSuccess({
          circles: circlesResponse.data.map((c) => ({
            guid: c.guid,
            name: c.name,
            adminId: c.adminId,
            organizationName: c.organizationName
          }))
        })
      );
    } catch (error) {
      if (getState().organizationContext.activeOrgGuid !== orgGuidAtStart) return;
      dispatch(
        slice.actions.hasError(
          error instanceof Error ? error.message : 'Failed to load sidebar content'
        )
      );
    }
  };
}
